import { Alert, Typography } from '@mui/material'
import React, { useMemo } from 'react'

import { getFailedNodeDetails } from 'components/scenarios/utils/graph/nodes/get-failed-node-details'

import type { ScenarioRunResponse } from 'types/api/scenarios/runs/scenario-runs'
import type { Scenario } from 'types/api/scenarios/scenario'

export const ScenarioFailureAlert: React.FC<{
  run?: ScenarioRunResponse
  scenario: Pick<Scenario, 'graph'>
}> = ({ run, scenario }) => {
  const { graph } = run ?? scenario

  const reason = useMemo(() => {
    const {
      failedReason,
      haltReason,
      haltSource,
      haltedByNodeName: name,
      haltedByNodeReason: message,
      haltedByNodeSemanticType: type
    } = run?.stage_info?.stageMetadata ?? {}

    if (name && type) {
      return {
        name,
        message,
        type
      }
    }

    const failMessageResponse = failedReason ?? haltReason

    return getFailedNodeDetails(graph, failMessageResponse, haltSource)
  }, [graph, run?.stage_info])

  if (!reason) {
    return null
  }

  const hasNameOrType = reason.name || reason.type

  return (
    <Alert severity="error" sx={{ width: '100%' }}>
      {hasNameOrType && (
        <Typography variant="body2">
          Halted by{' '}
          {reason.type && (
            <Typography component="span" variant="body2">
              {reason.type}{' '}
            </Typography>
          )}
          {reason.name && (
            <Typography
              component="span"
              sx={{ fontWeight: 'bold' }}
              variant="body2"
            >
              {reason.name}
            </Typography>
          )}
        </Typography>
      )}
      {reason.message && (
        <Typography
          component="code"
          sx={{ fontFamily: 'monospace' }}
          variant="body2"
        >
          {reason.message}
        </Typography>
      )}
    </Alert>
  )
}
